const getExpandedSubcategories = state =>
  state.subcategoriesPageUI.expandedSubcategories;

export default getExpandedSubcategories;
